// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Translations
import { withTranslation } from "react-i18next";
// Components
import Select from "components/Input/select";
// Application
import { ElementsHandleAPI } from "vendor/application/handleMethods";
// Infrastructure
import { BillingAPI } from "views/Order/infrastructure";
// Vendor
import { getBillingBody, isValidEmail, sortBy } from "vendor/application";
import { showNotify } from "vendor/application/disptach";
import "views/Order/styles/index.scss";

class Tab01 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countries: "",
      allCountries: "",
      province: "",
      billing: "",
      statusBilling: ""
    };
  }

  componentDidMount() {
    this.getBilling();
  }

  getBilling = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(user.account_id, access, this.props, null);
      let res = await obj.get_billing();
      this.setState({ billing: res, statusBilling: "put" });
    } catch (err) {
      this.setState({ billing: getBillingBody(), statusBilling: "post" });
    }
    this.getCountries();
  };

  getCountries = async () => {
    const { access } = this.props.data;
    try {
      const obj = new BillingAPI(null, access, this.props, null);
      let res = await obj.get_countries();
      this.handleCountries(res);
    } catch (err) {}
  };

  handleCountries = (data) => {
    var c = [],
      p = [],
      sp = false,
      currency = "",
      tax = "",
      countries;

    if (this.state.allCountries) {
      countries = this.state.allCountries;
    } else {
      countries = data;
      this.setState({ allCountries: data });
    }

    countries.forEach((country) => {
      if (!sp || country.country !== "Spain") {
        c.push(country);
        sp = true;
      }
      if (this.state.billing.country === country.country) {
        currency = country.currency;
        if (this.state.billing.province === country.province) {
          tax = country.tax;
        }
      }

      if (country.country === "Spain") {
        p.push(country);
      }
    });

    this.setState({ province: sortBy(p, "province"), countries: c });
    this.props.updateCurrency(currency, tax);
  };

  // update element state
  updateElement(e, type) {
    const { billing } = this.state;
    const obj = new ElementsHandleAPI(billing, e.target.value, type);
    const res = obj.updateObj();

    this.setState({ billing: res });
  }

  updateCountry = (e) => {
    this.state.billing.country = e;

    if (e !== "Spain") {
      this.state.billing.province = "";
    }

    this.handleCountries(this.state.countries);

    this.setState({ billing: this.state.billing });

    if (
      this.state.statusBilling === "put" &&
      ((this.state.billing.province && e === "Spain") ||
        (!this.state.billing.province && e !== "Spain"))
    ) {
      this.handleBilling();
    }
  };

  updateProvince = (e) => {
    this.state.billing.province = e;

    this.handleCountries(this.state.countries);

    this.setState({ billing: this.state.billing });

    if (this.state.statusBilling === "put") {
      this.handleBilling();
    }
  };

  handleBilling = async (redirect) => {
    const { billing, statusBilling } = this.state;
    const { existResume, handleOrder } = this.props;

    if (isValidEmail(billing.email)) {
      switch (statusBilling) {
        case "post":
          this.postBilling(redirect);
          break;
        case "put":
          this.putBilling(redirect);
          break;
      }

      if (!existResume && statusBilling !== "post") {
        handleOrder();
      }
    } else {
      var data = {
        message: "email_not_valid",
        from: "billing",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  postBilling = async (redirect) => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(
        user.account_id,
        access,
        this.props,
        this.state.billing
      );
      let res = await obj.post_billing();
      this.setState({ billing: res, statusBilling: "put" });
      this.props.handleOrder();
      this.props.getOrder();
      if (redirect) {
        this.props.handleTabsComponents(2);
      }
    } catch (err) {
      var data = { message: err, from: "order", severity: "error" };
      this.props.dispatch(showNotify(data));
    }
  };

  putBilling = async (redirect) => {
    const { access, user } = this.props.data;
    try {
      const obj = new BillingAPI(
        user.account_id,
        access,
        this.props,
        this.state.billing
      );
      let res = await obj.put_billing(this.state.billing.id);
      this.setState({ billing: res });
      this.props.getOrder();
      if (redirect) {
        this.props.handleTabsComponents(2);
      }
    } catch (err) {
      var data = {
        message: err.responseJSON.message,
        from: "order",
        severity: "error"
      };
      this.props.dispatch(showNotify(data));
    }
  };

  render() {
    const { t, tab } = this.props;
    const { countries, province, billing } = this.state;
    return (
      billing &&
      tab === 1 && (
        <React.Fragment>
          <span>{t("billing:tab_01.sub_title_01")}</span>
          <div className="man-module">
            <input
              placeholder={t("inputs:input.firstname_placeholder")}
              maxLength="50"
              name="name"
              value={billing.name}
              onChange={(e) => this.updateElement(e, "name")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.lastname_placeholder")}
              maxLength="50"
              name="lastname"
              value={billing.lastname}
              onChange={(e) => this.updateElement(e, "lastname")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.dni_placeholder")}
              name="dni"
              value={billing.dni}
              onChange={(e) => this.updateElement(e, "dni")}
              type="text"
            />
            <input
              autoComplete="nope"
              placeholder={t("inputs:input.email_placeholder")}
              name="email"
              value={billing.email}
              onChange={(e) => this.updateElement(e, "email")}
              type="email"
            />
            <input
              type="text"
              placeholder={t("inputs:input.phone_placeholder")}
              name="phone"
              value={billing.phone}
              onChange={(e) => this.updateElement(e, "phone")}
            />
          </div>
          <div className="man-module">
            <input
              placeholder={t("inputs:input.cif_nif_placeholder")}
              name="cif_nif"
              value={billing.cif_nif}
              onChange={(e) => this.updateElement(e, "cif_nif")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.company_placeholder")}
              name="company"
              maxLength="50"
              value={billing.company}
              onChange={(e) => this.updateElement(e, "company")}
              type="text"
            />
            <div></div>
          </div>
          <div className="man-module">
            <input
              placeholder={t("inputs:input.address_placeholder")}
              maxLength="100"
              name="address"
              value={billing.address}
              onChange={(e) => this.updateElement(e, "address")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.floor_placeholder")}
              maxLength="20"
              name="floor"
              value={billing.floor}
              onChange={(e) => this.updateElement(e, "floor")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.door_placeholder")}
              maxLength="20"
              name="door"
              value={billing.door}
              onChange={(e) => this.updateElement(e, "door")}
              type="text"
            />
          </div>
          <div className="man-module">
            <input
              placeholder={t("inputs:input.city_placeholder")}
              name="city"
              value={billing.city}
              onChange={(e) => this.updateElement(e, "city")}
              type="text"
            />
            <input
              placeholder={t("inputs:input.postal_code_placeholder")}
              maxLength="20"
              name="postal_code"
              value={billing.postal_code}
              onChange={(e) => this.updateElement(e, "postal_code")}
              type="number"
            />
          </div>
          <div className="man-module">
            <Select
              strSelected={billing.country}
              array={countries}
              onSelect={this.updateCountry}
              placeholder={t("inputs:input.country_placeholder")}
              value={"country"}
              id={"select-billing-country"}
              t={t}
            />
            {billing.country === "Spain" && (
              <Select
                strSelected={billing.province}
                array={province}
                onSelect={this.updateProvince}
                placeholder={t("inputs:input.province_placeholder")}
                value={"province"}
                id={"select-billing-province"}
                t={t}
              />
            )}
            <div></div>
          </div>
          <div className="man-actions">
            <button
              onClick={(e) => this.handleBilling("next")}
              className="btn btn-green"
            >
              {t("inputs:button.next")}
            </button>
          </div>
        </React.Fragment>
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_ = connect(mapStateToProps)(Tab01);
export default withTranslation(["order", "inputs", "billing"])(
  withRouter(connect_)
);
